import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react';
import { Button, DigitInputs, Link, ToastNotification } from '@philips-internal/oswald-ui-components';
import { Size, ToastLevel } from '@philips-internal/oswald-ui-constants';
import { ConfigurationService, MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isContentfulString } from '@philips-internal/oswald-ui-utils';
import './multi-factor-authentication.css';
function InternalMultiFactorAuthentication(props, ref) {
    const { codeSize = 6, continueExpression = 'tws.mfa.continue', inputCodeExpression = 'tws.mfa.input-code', resendCodeExpression = 'tws.mfa.resend-code', } = props;
    const [code, setCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const resendMultiFactorAuthentication = Boolean(ConfigurationService.getAuthenticationConfiguration()?.endpoints
        .multiFactor?.resend);
    useImperativeHandle(ref, () => ({
        setErrorMessage,
    }));
    const onDigitsReady = useCallback((event) => {
        setCode(event.value);
    }, []);
    const onContinueClick = useCallback(() => {
        props.onSendCode(code);
    }, [code]);
    return (React.createElement("div", { className: "c-multi-factor-authentication__content" },
        isContentfulString(errorMessage) ? (React.createElement(ToastNotification, { className: "c-multi-factor-authentication__notification", dismissible: false, inline: true, level: ToastLevel.ERROR, message: MessageService.translate(errorMessage), showIcon: true })) : null,
        React.createElement("div", { className: "c-multi-factor-authentication__header" },
            React.createElement("span", null, MessageService.translate(inputCodeExpression))),
        React.createElement("div", { className: "c-multi-factor-authentication__input" },
            React.createElement(DigitInputs, { digits: codeSize, onReady: onDigitsReady }),
            React.createElement(Button, { onClick: onContinueClick, value: continueExpression })),
        React.createElement("div", { className: "c-multi-factor-authentication__extra-content u-hide@empty" }, resendMultiFactorAuthentication ? (React.createElement(Link, { onClick: props.onResendCode, size: Size.LARGE, value: resendCodeExpression })) : null)));
}
const MultiFactorAuthentication = forwardRef(InternalMultiFactorAuthentication);
export { MultiFactorAuthentication, };
//# sourceMappingURL=multi-factor-authentication.js.map